const OPEN_CLASS = 'is-open';

export function initMenu() {
  const toggle = document.querySelector('.js-menu-toggle');
  if (!toggle) {
    return;
  }

  const nav = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!nav) {
    return;
  }

  const setOpen = (open) => {
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('is-menu-open', open);

    if (open) {
      nav.hidden = false;
      // hidden 解除直後の状態を一度確定させてからクラスを付け、フェードイン（項目の時間差表示を含む）を走らせる
      void nav.offsetWidth;
      nav.classList.add(OPEN_CLASS);
      return;
    }

    nav.classList.remove(OPEN_CLASS);
    nav.addEventListener(
      'transitionend',
      () => {
        if (toggle.getAttribute('aria-expanded') === 'false') {
          nav.hidden = true;
        }
      },
      { once: true },
    );
  };

  toggle.addEventListener('click', () => {
    setOpen(toggle.getAttribute('aria-expanded') !== 'true');
  });

  nav.querySelectorAll('.js-menu-link').forEach((link) => {
    link.addEventListener('click', () => setOpen(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
      setOpen(false);
      toggle.focus();
    }
  });
}
